/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserQueryResultOrg from './UserQueryResultOrg';

/**
 * The UserQueryResult model module.
 * @module model/UserQueryResult
 * @version 1.0
 */
class UserQueryResult {
    /**
     * Constructs a new <code>UserQueryResult</code>.
     * @alias module:model/UserQueryResult
     */
    constructor() { 
        
        UserQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserQueryResult} obj Optional instance to populate.
     * @return {module:model/UserQueryResult} The populated <code>UserQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserQueryResult();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('org')) {
                obj['org'] = UserQueryResultOrg.constructFromObject(data['org']);
            }
            if (data.hasOwnProperty('parentUserId')) {
                obj['parentUserId'] = ApiClient.convertToType(data['parentUserId'], 'Number');
            }
            if (data.hasOwnProperty('role')) {
                obj['role'] = ApiClient.convertToType(data['role'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
UserQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
UserQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
UserQueryResult.prototype['id'] = undefined;

/**
 * @member {String} name
 */
UserQueryResult.prototype['name'] = undefined;

/**
 * @member {module:model/UserQueryResultOrg} org
 */
UserQueryResult.prototype['org'] = undefined;

/**
 * @member {Number} parentUserId
 */
UserQueryResult.prototype['parentUserId'] = undefined;

/**
 * @member {String} role
 */
UserQueryResult.prototype['role'] = undefined;

/**
 * @member {String} updatedAt
 */
UserQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {String} username
 */
UserQueryResult.prototype['username'] = undefined;






export default UserQueryResult;

